<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="검색어"
                [(ngModel)]="searchValue"
                (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickSearch()">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col"></div>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0">
        <thead class="">
            <th>
                사업자번호
            </th>
            <th>
                단말번호
            </th>
            <th>
                차량번호
            </th>
            <th>
                업로드여부
            </th>
            <th>
                서비스시작
            </th>
            <th>
                마지막업로드
            </th>
            <th [hidden]="listType === DtgListType.modal">
                편집
            </th>
        </thead>
        <tbody class="">
            <ng-container *ngIf="listCar">
                <tr *ngFor="let item of listCar;">
                    <td>
                        {{item.dtgEid}}
                    </td>
                    <td>
                        {{item.dtgUnitId}}
                    </td>
                    <td>
                        {{item.dtgCarNo}}
                    </td>
                    <td>
                        {{item.useYn}}
                    </td>
                    <td>
                        {{item.serviceDtFrom}}
                    </td>
                    <td>
                        {{item.lastUpDt}}
                    </td>
                    <td [hidden]="listType === DtgListType.modal">
                        <button type="button" class="btn btn-sm btn-outline-secondary"
                            (click)="clickOpenModalFormEtasCar(DtgActionType.update,item)">
                            <i class="mdi mdi-pen"></i>
                            <span class="ml-1">수정</span>
                        </button>
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngIf="!listCar">
                <tr>
                    <td colspan="7" class="text-center">
                        표시 할 내용이 없습니다
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>

<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
</div>